import config from '../../../config';
import {
  checkStatus,
  handleRequestError,
} from '../../utils/helpers';

import {
  UPDATE_CUSTOMER_UPDATE_FIELD,
  UPDATE_CUSTOMER_TOUCH_FIELD,
  UPDATE_CUSTOMER_VALIDATE_FIELD,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMERP_CLEAR_SUCCESS,
} from './constants';

const validateField = (id, countryCode, shop) => ({
  type: UPDATE_CUSTOMER_VALIDATE_FIELD,
  payload: { id, countryCode, shop },
});

export const touchField = (id, countryCode, shop) => (dispatch) => {
  dispatch({
    type: UPDATE_CUSTOMER_TOUCH_FIELD,
    payload: id,
  });

  return dispatch(validateField(id, countryCode, shop));
};

export const updateField = (id, value, countryCode, shop) => (dispatch) => {
  dispatch({
    type: UPDATE_CUSTOMER_UPDATE_FIELD,
    payload: { id, value },
  });

  return dispatch(validateField(id, countryCode, shop));
};

export const showSuccess = () => ({
  type: UPDATE_CUSTOMER_SUCCESS,
});

export const clearSuccess = () => ({
  type: UPDATE_CUSTOMERP_CLEAR_SUCCESS,
});

export const updateCustomerInfo = (id, customerData, tokenData, subscriptionId) => (dispatch) => {
  const url = `${config.url}/customer/${id}/info`;

  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...customerData,
      token: tokenData.id,
      subscriptionId,
    }),
  }).then(checkStatus)
    .then(() => dispatch(showSuccess()))
    .catch(handleRequestError(dispatch));
};



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/actions.js